import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_BASE_URL
// 🔴 **Kein `X-Admin-Key` mehr** (04.11.2026). Die vier lesenden Agentenrouten
// tragen die Kontenliste des Tores statt des Schluessels; das Bearer-JWT setzt
// der axios-Interceptor der App. Ein mitgeschickter Schluessel wuerde ignoriert —
// ihn weiter zu senden hiesse, einen Schluessel ins Browserbuendel zu backen,
// den niemand mehr braucht.

/**
 * useAgentZahlen: der Tagesstand des Agenten fuer die Zahlen neben dem Schalter
 * (N102, A7).
 *
 * @description
 *   Ein Aufruf: `GET /api/agent/zahlen`. Die Antwort traegt auch die Schalterlage
 *   (`schalter`: `an` / `aus` / `unbekannt`) — ein Datenbankausfall kommt also
 *   nicht als HTTP-Fehler, sondern als Feld, und die Anzeige muss ihn dort lesen.
 *
 *   🔴 Eigener Haken und nicht in `useSettings` hinein: der Schalterumschlag und
 *   die Zahlen haben verschiedene Lebensdauern. Ein Speichern zieht die
 *   Einstellungen neu; die Zahlen aendern sich dagegen im Takt des Abarbeiters,
 *   ohne dass jemand klickt. Waeren sie ein Feld derselben Antwort, saehe der
 *   Owner nach einem Speichern alte Zahlen, weil nichts sie nachgeladen hat.
 *
 * @useWhen
 *   - In `AdminSettings`, einmal je Seite; die Anzeige bekommt das Ergebnis
 *
 * @dontUseFor
 *   - Fuer die Einordnung eines einzelnen Falls (`useEinordnung`) — anderer Umfang
 *
 * @related
 *   - useSettings: dieselbe Bauform, eigene Anmeldung
 *   - AgentZahlen: die Anzeige; sie holt ihre Daten nicht selbst
 *
 * @param {number} version  Zaehler erfolgreicher Schreibvorgaenge; jede
 *   Erhoehung loest einen neuen Abruf aus (N102 B1).
 *
 * @returns {{zahlen, loading, error, reload}}
 */
export default function useAgentZahlen(version = 0) {
  const [zahlen, setZahlen] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const r = await axios.get(`${API}/api/agent/zahlen`)
      setZahlen(r.data || null)
    } catch (e) {
      setError(e?.response?.data?.error || e?.message || 'agent_numbers_failed')
    } finally {
      setLoading(false)
    }
  }, [])

  // `version` zaehlt die erfolgreichen Schreibvorgaenge des Admin-Blattes (N102 B1):
  // steigt sie, liest die Anzeige neu. Ohne sie bliebe der Stand neben dem
  // Schalter nach dem Umlegen alt.
  useEffect(() => { load() }, [load, version])

  return { zahlen, loading, error, reload: load }
}
